import axiosClient from "../../../service/axios";
import {
  ADD_AGENT_URL,
  ADD_DISPATCH,
  CANCEL_ORDER_URL,
  DASHBOARD_URL,
  DISABLE_AGENT_URL,
  DISABLE_DISPATCH_URL,
  ENABLE_AGENT_URL,
  ENABLE_DISPATCH_URL,
  FETCH_AGENT_URL,
  GET_HOSPITALS_URL,
  GET_PIPELINES_URL,
  GET_VENDORS_URL,
  PREMIUM_LIST_URL,
  TICKET_URL,
  UPDATE_DISPATCH_URL,
  UPDATE_HOSPITAL_URL,
  UPDATE_TICKET_URL,
  RIDER_DETAILS_URL,
  CYLINDER_LIST_URL,
  CYLINDER_SERIES_URL,
  CYLINDERS_URL,
  PLANTS_URL,
  ADD_CODE_URL,
  CYLINDER_DETAILS_URL,
  GET_NOTIFICATION_URL,
  CREATE_NOTIFICATION_URL,
  DELETE_NOTIFICATION_URL,
  GET_NERVE_CLAIM,
  SEND_NERVE_CLAIM,
  CRADLE_REQUEST,
  CRADLE_UPDATE,
  INCIDENT_REPORT,
  INCIDENT_REPORT_POST,
  NOTIFY_NERVE,
  NOTIFY_NERVE_POST,
  DELETE_NERVE_POST,
  SHOW_ALL_PO,
  SHOW_COHORT,
  CREATE_COHORT,
  SHOW_COHORT_LIST,
  SEND_COHORT,
  ADD_HOSPITAL_COHORT,
  GET_ALL_MY_COHORT,
  SEE_QUOTATION,
  SINGLE_QUOTATION,
  SEND_QUOTATION,
} from "./admin.endpoints";

/*
@get admin dashboard count

*/
const fetchDashboardCount = async () => {
  try {
    return await axiosClient.get(DASHBOARD_URL);
  } catch (error) {
    return error;
  }
};

/*
@show all po 
@get tickets

*/

// @show all po

const showAllPo = async () => {
  try {
    return await axiosClient.get(SHOW_ALL_PO);
  } catch (error) {
    return error;
  }
};

const fetchTickets = async () => {
  try {
    return await axiosClient.get(TICKET_URL);
  } catch (error) {
    return error;
  }
};

// add dispatch rider
const createDispatch = async (details) => {
  try {
    return await axiosClient.post(ADD_DISPATCH, details);
  } catch (error) {
    return error;
  }
};

// add dispatch rider
const updateDispatch = async (details) => {
  try {
    return await axiosClient.post(UPDATE_DISPATCH_URL, details);
  } catch (error) {
    return error;
  }
};

// get all agents
const fetchAgents = async () => {
  try {
    return await axiosClient.get(FETCH_AGENT_URL);
  } catch (error) {
    return error;
  }
};

// add dispatch rider
const createAgent = async (details) => {
  try {
    return await axiosClient.post(ADD_AGENT_URL, details);
  } catch (error) {
    return error;
  }
};

/*
@Enable agent

*/
const enableAgent = async (id) => {
  try {
    return await axiosClient.put(ENABLE_AGENT_URL + id);
  } catch (error) {
    return error;
  }
};

/*
@Disable agent

*/
const disableAgent = async (id) => {
  try {
    return await axiosClient.put(DISABLE_AGENT_URL + id);
  } catch (error) {
    return error;
  }
};

/*
@Enable dispatch

*/
const enableDispatch = async (id) => {
  try {
    return await axiosClient.put(ENABLE_DISPATCH_URL + id);
  } catch (error) {
    return error;
  }
};

/*
@Disable dispatch

*/
const disableDispatch = async (id) => {
  try {
    return await axiosClient.put(DISABLE_DISPATCH_URL + id);
  } catch (error) {
    return error;
  }
};

/*
@fetch hospitals

*/
const fetchHospitals = async () => {
  try {
    return await axiosClient.get(GET_HOSPITALS_URL);
  } catch (error) {
    return error;
  }
};

const fetchPipelines = async () => {
  try {
    return await axiosClient.get(GET_PIPELINES_URL);
  } catch (error) {
    return error;
  }
};  

/*
@fetch notification

*/
const fetchNotifications = async () => {
  try {
    return await axiosClient.get(GET_NOTIFICATION_URL);
  } catch (error) {
    return error;
  }
};

/*
@create notification

*/
const createNotifications = async (details) => {
  try {
    return await axiosClient.post(CREATE_NOTIFICATION_URL, details);
  } catch (error) {
    return error;
  }
};

/*
@delete notification

*/
const deleteNotifications = async (id) => {
  try {
    return await axiosClient.delete(DELETE_NOTIFICATION_URL + id);
  } catch (error) {
    return error;
  }
};

/*
@fetch vendors

*/
const fetchVendors = async () => {
  try {
    return await axiosClient.get(GET_VENDORS_URL);
  } catch (error) {
    return error;
  }
};

/*
@fetch cylinder 

*/
const fetchCylinder = async () => {
  try {
    return await axiosClient.get(CYLINDER_LIST_URL);
  } catch (error) {
    return error;
  }
};

/*
@fetch cylinder sizes

*/
const fetchCylinderSize = async () => {
  try {
    return await axiosClient.get(CYLINDERS_URL);
  } catch (error) {
    return error;
  }
};

/*
@fetch plants

*/
const fetchPlants = async () => {
  try {
    return await axiosClient.get(PLANTS_URL);
  } catch (error) {
    return error;
  }
};

/*
@Enable agent

*/
const fetchCylinderSeries = async (id) => {
  try {
    return await axiosClient.get(CYLINDER_SERIES_URL + id);
  } catch (error) {
    return error;
  }
};

/*
@Enable agent

*/
const fetchCylinderDetails = async () => {
  try {
    return await axiosClient.get(CYLINDER_DETAILS_URL);
  } catch (error) {
    return error;
  }
};

/*
@cancel order

*/
const cancelOrder = async (details) => {
  try {
    return await axiosClient.post(CANCEL_ORDER_URL, details);
  } catch (error) {
    return error;
  }
};

/*
@update hospital

*/
const UpdateHospital = async (details) => {
  try {
    return await axiosClient.post(UPDATE_HOSPITAL_URL, details);
  } catch (error) {
    return error;
  }
};

/*
@premium list

*/
const premiumList = async () => {
  try {
    return await axiosClient.get(PREMIUM_LIST_URL);
  } catch (error) {
    return error;
  }
};

/*
@Update Ticket

*/
const updateTicket = async (details) => {
  try {
    return await axiosClient.post(UPDATE_TICKET_URL, details);
  } catch (error) {
    return error;
  }
};

/*
@Rider Details

*/
const riderDetails = async (details) => {
  try {
    return await axiosClient.post(RIDER_DETAILS_URL, details);
  } catch (error) {
    return error;
  }
};

/*
@Add Code

*/
const addCode = async (details) => {
  try {
    return await axiosClient.post(ADD_CODE_URL, details);
  } catch (error) {
    return error;
  }
};

const getNerveClaims = async () => {
  try {
    return await axiosClient.get(GET_NERVE_CLAIM);
  } catch (error) {
    return error;
  }
};

const sendNerveClaims = async (details) => {
  try {
    return await axiosClient.post(SEND_NERVE_CLAIM, details);
  } catch (error) {
    return error;
  }
};
const getcradleRequest = async () => {
  try {
    return await axiosClient.get(CRADLE_REQUEST);
  } catch (error) {
    return error;
  }
};

const postCradleUpdate = async (detail) => {
  try {
    return await axiosClient.post(CRADLE_UPDATE, detail);
  } catch (error) {
    return error;
  }
};
const incidentReport = async () => {
  try {
    return await axiosClient.get(INCIDENT_REPORT);
  } catch (error) {
    return error;
  }
};

const incidentReportPost = async (detail) => {
  try {
    return await axiosClient.post(INCIDENT_REPORT_POST, detail);
  } catch (error) {
    return error;
  }
};

const notifyNerve = async () => {
  try {
    return await axiosClient.get(NOTIFY_NERVE);
  } catch (error) {
    return error;
  }
};
const showAllCohort = async () => {
  try {
    return await axiosClient.get(SHOW_COHORT);
  } catch (error) {
    return error;
  }
};

const createCohort = async (detail) => {
  try {
    return await axiosClient.post(CREATE_COHORT, detail);
  } catch (error) {
    console.log("error", error);
    return error;
  }
};

const getAllmyHospitalCohort = async () => {
  try {
    return await axiosClient.get(GET_ALL_MY_COHORT);
  } catch (error) {
    return error;
  }
};

const addHospitalCohort = async (detail) => {
  try {
    return await axiosClient.post(ADD_HOSPITAL_COHORT, detail);
  } catch (error) {
    return error;
  }
};

const notifyNervePost = async (detail) => {
  try {
    return await axiosClient.post(NOTIFY_NERVE_POST, detail);
  } catch (error) {}
};

const deletePost = async (id) => {
  try {
    return await axiosClient.delete(DELETE_NERVE_POST + id);
  } catch (error) {
    return error;
  }
};

const gethospitalCohort = async (id) => {
  try {
    return await axiosClient.get(SHOW_COHORT_LIST + id);
  } catch (error) {
    return error;
  }
};

const sendCohort = async (detail) => {
  try {
    return await axiosClient.post(SEND_COHORT, detail);
  } catch (error) {
    return error;
  }
};

const seeQuotation = async () => {
  try {
    return await axiosClient.get(SEE_QUOTATION);
  } catch (error) {
    return error;
  }
};

const singleQuotation = async (id) => {
  try {
    return await axiosClient.get(SINGLE_QUOTATION + id);
  } catch (error) {
    return error;
  }
};

const sendQuotation = async (id) => {
  try {
    return await axiosClient.post(SEND_QUOTATION + id);
  } catch (error) {
    return error;
  }
};

// const deleteCohort =

const AdminService = {
  showAllPo,
  seeQuotation,
  getAllmyHospitalCohort,
  showAllCohort,
  fetchDashboardCount,
  fetchTickets,
  createDispatch,
  fetchAgents,
  createAgent,
  enableAgent,
  disableAgent,
  enableDispatch,
  disableDispatch,
  updateDispatch,
  fetchHospitals,
  fetchPipelines,
  fetchVendors,
  cancelOrder,
  UpdateHospital,
  premiumList,
  updateTicket,
  riderDetails,
  fetchCylinder,
  fetchCylinderSeries,
  fetchPlants,
  fetchCylinderSize,
  addCode,
  fetchCylinderDetails,
  fetchNotifications,
  createNotifications,
  deleteNotifications,
  getNerveClaims,
  sendNerveClaims,
  getcradleRequest,
  postCradleUpdate,
  incidentReport,
  incidentReportPost,
  notifyNerve,
  notifyNervePost,
  deletePost,
  createCohort,
  gethospitalCohort,
  sendCohort,
  addHospitalCohort,
  singleQuotation,
  sendQuotation,
};

export default AdminService;
